import { Component, ElementRef, HostListener, Inject, Injector, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent } from '../../../../commons/abstract.component';

@Component({
    selector: 'lib-irrelevance-reopening-modal',
    // templateUrl: './irrelevance-reopening-modal.component.html',
    templateUrl: './irrelevance-reopening-modal.v2.component.html',
    styleUrl: './irrelevance-reopening-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IrrelevanceReopeningModalComponent extends AbstractComponent {
  @ViewChild('firstInput') firstInput: ElementRef;

  public isFilterActive = false;
  public newIrrelevantWord = '';
  public irrelevantWordsList: string[] = [];

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IrrelevanceReopeningModalComponent>
  ) {
    super(injector);
    this.initializeIrrelevantWordsList();
  }

  ngOnInit(): void {
    this.isNew = !this.data.filterIrrelevantMessages;
    this.updateButtonState();
    this.changeIrrelevantMessages();
  }

  @HostListener('keydown.enter', ['$event'])
  handleEnterKey(event: Event): void {
    event.preventDefault();
    this.processInput();
  }

  onInputChange(event?: any): void {
    if (this.newIrrelevantWord.trim().endsWith(',')) {
      this.processInput();
    }

    this.updateButtonState();
  }

  removeIrrelevantWord(word: string): void {
    this.irrelevantWordsList = this.irrelevantWordsList.filter((w) => w !== word);
    this.updateButtonState();
  }

  onSave(): void {
    this.changeIrrelevantMessages();

    const updatedData = {
      ...this.data,
      irrelevantWords: [
        ...new Set(
          this.irrelevantWordsList.map((word) =>
            word
              .trim()
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
          )
        ),
      ],
      periodToIgnoreAttendance: this.data.periodToIgnoreAttendance,
      preventReopenForEmojiOnly: this.data.preventReopenForEmojiOnly,
    };

    this.dialogRef.close(updatedData);
  }

  onClose(): void {
    this.dialogRef.close();
  }
  private processInput(): void {
    const input = this.newIrrelevantWord.trim().replace(/[,]+$/, '');

    if (input) {
      this.addNewWords(input);
      this.newIrrelevantWord = '';
    }
  }

  private initializeIrrelevantWordsList(): void {
    this.irrelevantWordsList = Array.isArray(this.data?.irrelevantWords)
      ? [
        ...new Set(
          (this.data.irrelevantWords as string[])
            .filter((word): word is string => typeof word === 'string')
            .map((word: string) =>
              word
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .trim()
                .toLowerCase()
            )
            .filter(word => word)
        ),
      ]
      : [];
  }

  private addNewWords(input: string): void {
    const newWords = input
      .split(',')
      .map(word => word.trim())
      .filter(word => {
        const isValid = !!word && word.length > 0;
        const isDuplicate = this.irrelevantWordsList.includes(word);

        if (isValid && isDuplicate) {
          this.alertService.error(this.t('shared.irrelevanceReopeningModal.wordAlreadyInList', { word }));
        }

        return isValid && !isDuplicate;
      });

    if (newWords.length > 0) {
      this.irrelevantWordsList = [...this.irrelevantWordsList, ...newWords];
    }
  }

  private updateButtonState(): void {
    this.isFilterActive = !!this.newIrrelevantWord.trim() || this.irrelevantWordsList.length > 0;
  }

  private changeIrrelevantMessages(): void {
    if (this.data.filterIrrelevantMessages) {
      if (this.irrelevantWordsList.length === 0) {
        this.alertService.error(this.t('shared.irrelevanceReopeningModal.wordsListCannotBeEmpty'));
      }

      if (!this.data.periodToIgnoreAttendance || this.data.periodToIgnoreAttendance <= 0) {
        this.alertService.error(this.t('shared.irrelevanceReopeningModal.minimumReopenTimeMustBeGreaterThanZero'));
      }
    }
  }
}
